import { Progress, Typography } from "@suraasa/placebo-ui"
import clsx from "clsx"

import styles from "./CourseInfoAndProgress.module.css"
import { getCourseName } from "./utils"

export const getPercentage = ({
  total,
  completed,
}: {
  total: number | null
  completed: number | null
}) => {
  if (!total || !completed) return 0
  return Math.floor((completed / total) * 100)
}

const CourseInfoAndProgress = ({
  className,
  highlightCourse = false,
  showCount = false,
  title,
  currentItemNumber,
  numberOfItems,
  barColor,
  courseCode,
}: {
  highlightCourse?: boolean
  showCount?: boolean
  className?: string
  title: string
  courseCode?: string | null
  currentItemNumber: number
  numberOfItems: number
  barColor?: "black"
}) => {
  const percentage = getPercentage({
    total: numberOfItems,
    completed: currentItemNumber,
  })
  return (
    <div
      className={clsx("grow pe-1", className, {
        "text-common-white-500": highlightCourse,
      })}
    >
      <Typography variant="strong" className="mb-1">
        {getCourseName({ title, courseCode })}
      </Typography>
      <div className="w-full max-w-[350px]">
        <Progress
          value={percentage}
          className={clsx({
            [styles.progressBar]: highlightCourse,
            [styles.blackLinearProgress]: barColor === "black",
          })}
          indicatorClassName={clsx({
            [styles.blackLinearProgressIndicator]: barColor === "black",
          })}
        />
        <div className="mt-0.5 flex items-center justify-between">
          <Typography variant="strongSmallBody">
            {showCount ? `${currentItemNumber}/${numberOfItems} Done` : ""}
          </Typography>
          <Typography variant="strongSmallBody">{percentage}%</Typography>
        </div>
      </div>
    </div>
  )
}

export default CourseInfoAndProgress
